import { Stack } from '@nautilusbio/nb-design-system/Stack';
import type { FC, ReactNode } from 'react';
import React from 'react';

export type DevControlsProps = {
  children?: ReactNode;
};

const DevControls: FC<DevControlsProps> = ({ children }) =>
  children ? (
    <Stack gap={3} orientation="vertical">
      {children}
    </Stack>
  ) : null;

export default DevControls;
